export default __webpack_public_path__ + "static/1704-6e39f0242f5772db041a12ccb9e714fd.gif";